// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 945) return "static/chunks/945-96df8331278733b8823f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 680 ? "db992716" : chunkId) + "." + {"29":"1f3ade28123f238c2a30","152":"fa85f4332e8a6eb45d4e","680":"9a4e47ec98450967f797","983":"b2756ea3201b835f785a"}[chunkId] + ".js";
};